import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {CollageFilterModel} from '../modules/imaging/image-collage/models/collage-filter.model';
import {DocumentDataModel} from '../models/document/document-data.model';

@Injectable({
  providedIn: 'root'
})
export class CollageService {

  constructor(private http: HttpClient) {

  }

  getCollages(filterModel: CollageFilterModel) {
    return this.http.post<DocumentDataModel[]>('api/canvas/get-collages', filterModel);
  }
}
